import request from '@/utils/request'


// 仓库查询
export function pageQuery(data) {
    return request({
        url: '/db/inventory-info/query',
        method: 'post',
        data
    })
}

// 出库记录一键导出
export function reportExport(data){
    return request({
        url:'/db/inventory-info/report-export',
        method:'post',
        data
    })
}

// export function reportExportProgress(data){
//     return request({
//         url:'/db/inventory-info/report-export-progress',
//         method:'post',
//         data
//     })
// }